import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class userInvite extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            email: "",
            error: false,
            isLoading: true
        };
    };

    componentWillMount() {
        this._updateItems();
    }

    _updateItems() {
        dataRegister.referred(salesChannelRegister.get('market')).then((response) => {
            if(!response.errors){
                this.setState({items: response, isLoading: false});
            }
        }, (error) => {
            this.setState({isLoading: false});
        });
    }

    _send(){
        if(this._emailValidation(this.state.email)){
            this.setState({isLoading: true});
            let refer = {referred: this.state.email};
            dataRegister.refer(salesChannelRegister.get('market'), refer).then((response) => {
                if(!response.errors){
                    this._updateItems();
                }else{
                    this.setState({error: response.errors, isLoading: false});
                }
            }, (error) => {
                this.setState({isLoading: false});
            });
        }
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _renderText(item) {
        return langRegister.get("user-invite", item);
    }

    render() {
        return (
            <div>
                <div>
                    <div className={Styles.contentHeader}>
                        <div className={Styles.contentHeaderSearch}>

                        </div>
                        <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                            {this._renderText("item_1")}
                        </div>
                    </div>
                    <div className={Styles.container}>
                        {
                            !this.state.isLoading &&
                            <div className={Styles.containerInner}>
                                <div className={Styles.contentInnerItem}>
                                    <div className={Styles.contentInnerItemHeader}>
                                        <div className={Styles.contentInnerItemHeaderTitle}>
                                            {this._renderText("item_2")}
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input placeholder={this._renderText("item_3")} value={this.state.email} onChange={(event) => this.setState({email: event.target.value})} className={Styles.input}/>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={
                                                cx(Styles.button,
                                                    {
                                                        [Styles.buttonActive]: this._emailValidation(this.state.email)
                                                    })
                                            } onClick={() => this._send()}>
                                                {this._renderText("item_4")}
                                            </div>
                                        </div>
                                        {
                                            this.state.error &&
                                            <div className={Styles.error}>
                                                {this.state.error}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {
                                    this.state.items &&
                                    this.state.items.map((item) => {
                                        return (
                                            <div className={Styles.contentInnerItemUsers}>
                                                <div className={Styles.contentInnerItemHeader}>
                                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                                        {item.reffered_email}
                                                    </div>
                                                </div>
                                                <div className={Styles.contentInnerItemValue}>
                                                    {
                                                        item.status === "pending" &&
                                                        <div className={Styles.contentInnerItemValueStatusPending}/>
                                                    }
                                                    {
                                                        !item.status === "pending" &&
                                                        <div className={Styles.contentInnerItemValueStatusActive}/>
                                                    }
                                                    <div className={Styles.contentInnerItemValueStatusName}>
                                                        {
                                                            item.status === "pending" &&
                                                            <span>{this._renderText("item_5")}</span>
                                                        }
                                                        {
                                                            !item.status === "pending" &&
                                                            <span>{this._renderText("item_6")}</span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                        {
                            this.state.isLoading &&
                            <div className={Styles.loader}>
                                <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                            </div>
                        }

                    </div>
                </div>
            </div>
        );
    }
}

export default userInvite;


// WEBPACK FOOTER //
// ./src/components/user-invite/component.js